module.exports = __webpack_public_path__ + "img/bg-old.4d736e74.png";